import React from 'react';

/**
** GroupModelAsParent
*! parent = COUNTRY   for Midas, Irrijardin, GuyHoquet
*! parent = TYPE      for Baglestein
*? modelCode = HIERARCHY_GROUP for Midas, Irrijardin, GuyHoquet
*? modelCode = HIERARCHY_GROUP for Midas, Irrijardin, GuyHoquet
/**/

/** HierarchyGroup Customer config
 *? modelCode = HIERARCHY_GROUP for Midas (MMC: check Irrijardin, GuyHoquet)
 *? sectorModelCode = AREA for Midas (MMC: check Irrijardin, GuyHoquet)
 **/

export interface HierarchyGroupsConfigBase {
    readonly hideParent: boolean;
    readonly parentModelCode: string;
    readonly modelCode: string;
}

export interface HierarchyGroupsConfig extends HierarchyGroupsConfigBase {
    readonly i18nKey: string;
    readonly createUrl: string;
    readonly listUrl: string;
    readonly editUrl: (id: string) => string;
}

export const DefaultSectorsConfig: HierarchyGroupsConfig = {
    hideParent: false,
    parentModelCode: 'AREA',
    modelCode: 'SECTOR',
    i18nKey: '',
    createUrl: '',
    listUrl: '',
    editUrl: (id: string) => '',
};

export const HierarchyGroupsContext =
    React.createContext<HierarchyGroupsConfig>(DefaultSectorsConfig);
export const useHierarchyGroupsConfig = () =>
    React.useContext<HierarchyGroupsConfig>(HierarchyGroupsContext);

export const SectorsContext = React.createContext<HierarchyGroupsConfigBase>(DefaultSectorsConfig);
export const useSectorsConfig = () => React.useContext<HierarchyGroupsConfigBase>(SectorsContext);
